var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.dialogTitle,
        width: "560px",
        "use-panel": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        cancel: _vm.handleClose,
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "sk-dialog__footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-cancel",
                      attrs: { plain: "" },
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v("Hủy")]
                  ),
                  _vm.actionType === "rename"
                    ? _c(
                        "el-button",
                        {
                          staticClass: "btn-save",
                          attrs: {
                            type: "primary",
                            disabled: !_vm.isNameChanged,
                            loading: _vm.isSaving,
                          },
                          on: { click: _vm.handleSave },
                        },
                        [
                          _c("i", { staticClass: "el-icon-check" }),
                          _vm._v(" Lưu thay đổi\n      "),
                        ]
                      )
                    : _vm._e(),
                  _vm.actionType === "delete"
                    ? _c(
                        "el-button",
                        {
                          staticClass: "btn-delete",
                          attrs: { type: "danger", loading: _vm.isDeleting },
                          on: { click: _vm.handleDelete },
                        },
                        [
                          _c("i", { staticClass: "el-icon-delete" }),
                          _vm._v(" Xác nhận xóa khoản thu\n      "),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "sk-dialog__content" }, [
        _c("div", { staticClass: "rfd-action-switch" }, [
          _c(
            "button",
            {
              staticClass: "rfd-switch-btn",
              class: { "is-active": _vm.actionType === "rename" },
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  _vm.actionType = "rename"
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-edit-outline" }),
              _c("span", [_vm._v("Đổi tên khoản thu")]),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "rfd-switch-btn rfd-switch-btn--danger",
              class: { "is-active": _vm.actionType === "delete" },
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  _vm.actionType = "delete"
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-delete" }),
              _c("span", [_vm._v("Xóa khoản thu")]),
            ]
          ),
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.actionType === "rename",
                expression: "actionType === 'rename'",
              },
            ],
          },
          [
            _c("div", { staticClass: "sk-panel" }, [
              _c("div", { staticClass: "sk-panel-head" }, [
                _c("div", { staticClass: "sk-panel-icon" }, [
                  _c("i", { staticClass: "el-icon-collection-tag" }),
                ]),
                _c("div", [
                  _c("p", { staticClass: "sk-panel-title" }, [
                    _vm._v("Thông tin khoản thu hiện tại"),
                  ]),
                  _c("p", { staticClass: "sk-panel-subtitle" }, [
                    _vm._v("Khoản thu đang áp dụng trong danh sách phiếu thu"),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "rfd-info-grid" }, [
                _c(
                  "div",
                  { staticClass: "rfd-info-row" },
                  [
                    _c("span", { staticClass: "rfd-info-label" }, [
                      _vm._v("Mã khoản:"),
                    ]),
                    _c(
                      "el-tag",
                      {
                        staticClass: "rfd-info-code",
                        attrs: { size: "mini", type: "info", effect: "plain" },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.feeData.revenueCode || _vm.feeData.idx || "—"
                            ) +
                            "\n            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "rfd-info-row" }, [
                  _c("span", { staticClass: "rfd-info-label" }, [
                    _vm._v("Tên hiện tại:"),
                  ]),
                  _c("span", { staticClass: "rfd-info-name" }, [
                    _vm._v(
                      _vm._s(
                        _vm.feeData.currentName || _vm.feeData.label || "—"
                      )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "rfd-info-row" }, [
                  _c("span", { staticClass: "rfd-info-label" }, [
                    _vm._v("Đơn vị tính:"),
                  ]),
                  _c("span", { staticClass: "rfd-info-value" }, [
                    _vm._v(_vm._s(_vm.feeData.unit || "Tháng")),
                  ]),
                ]),
                _vm.feeData.price
                  ? _c("div", { staticClass: "rfd-info-row" }, [
                      _c("span", { staticClass: "rfd-info-label" }, [
                        _vm._v("Đơn giá mẫu:"),
                      ]),
                      _c("span", { staticClass: "rfd-info-value" }, [
                        _vm._v(
                          _vm._s(_vm._f("formatCurrency")(_vm.feeData.price))
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "rfd-info-row" }, [
                  _c("span", { staticClass: "rfd-info-label" }, [
                    _vm._v("Phạm vi:"),
                  ]),
                  _c("span", { staticClass: "rfd-info-value" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.feeData.targetType === "GROUP" ? "Nhóm" : "Lớp"
                        ) +
                        "\n              " +
                        _vm._s(
                          _vm.feeData.targetName || _vm.feeData.className || "—"
                        ) +
                        "\n            "
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "rfd-info-row" }, [
                  _c("span", { staticClass: "rfd-info-label" }, [
                    _vm._v("Kỳ áp dụng:"),
                  ]),
                  _c("span", { staticClass: "rfd-info-value" }, [
                    _vm._v(
                      "\n              Tháng " +
                        _vm._s(_vm.feeData.month) +
                        "/" +
                        _vm._s(_vm.feeData.year) +
                        " (Đợt " +
                        _vm._s(_vm.feeData.turn) +
                        ")\n            "
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "sk-panel sk-u-mt-12" },
              [
                _c("div", { staticClass: "sk-panel-head" }, [
                  _c(
                    "div",
                    { staticClass: "sk-panel-icon sk-panel-icon--success" },
                    [_c("i", { staticClass: "el-icon-edit" })]
                  ),
                  _c("div", [
                    _c("p", { staticClass: "sk-panel-title" }, [
                      _vm._v("Thiết lập tên mới"),
                    ]),
                    _c("p", { staticClass: "sk-panel-subtitle" }, [
                      _vm._v("Nhập tên hiển thị mới cho khoản thu này"),
                    ]),
                  ]),
                ]),
                _c(
                  "el-form",
                  {
                    ref: "formRef",
                    attrs: {
                      model: _vm.formData,
                      rules: _vm.formRules,
                      "label-position": "top",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "Tên khoản thu mới", prop: "newName" },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "Nhập tên khoản thu mới...",
                            maxlength: "150",
                            "show-word-limit": "",
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.handleSave.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.formData.newName,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "newName", $$v)
                            },
                            expression: "formData.newName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "sk-u-mt-12",
                        attrs: {
                          label: "Ghi chú điều chỉnh (tùy chọn)",
                          prop: "note",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 2,
                            placeholder: "Nhập lý do thay đổi tên...",
                            maxlength: "250",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.formData.note,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "note", $$v)
                            },
                            expression: "formData.note",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "sk-note sk-note--warning sk-u-mt-12" }, [
              _c("i", { staticClass: "el-icon-warning-outline" }),
              _c("span", [
                _vm._v(
                  "\n          Tên khoản thu sẽ được thay đổi cho tất cả các phiếu thu đã được khởi tạo của\n          " +
                    _vm._s(
                      _vm.feeData.targetType === "GROUP" ? "nhóm" : "lớp"
                    ) +
                    "\n          "
                ),
                _vm.feeData.targetName || _vm.feeData.className
                  ? _c("strong", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.feeData.targetName || _vm.feeData.className
                          ) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
                _vm._v("\n          trong tháng "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.feeData.month || "...") +
                      "/" +
                      _vm._s(_vm.feeData.year || "...")
                  ),
                ]),
                _vm._v("\n          đợt "),
                _c("strong", [_vm._v(_vm._s(_vm.feeData.turn || "..."))]),
                _vm._v(".\n        "),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.actionType === "delete",
                expression: "actionType === 'delete'",
              },
            ],
          },
          [
            _c("div", { staticClass: "sk-panel" }, [
              _c("div", { staticClass: "sk-panel-head" }, [
                _c(
                  "div",
                  { staticClass: "sk-panel-icon sk-panel-icon--danger" },
                  [_c("i", { staticClass: "el-icon-warning-outline" })]
                ),
                _c("div", [
                  _c("p", { staticClass: "sk-panel-title" }, [
                    _vm._v("Thông tin khoản thu cần xóa"),
                  ]),
                  _c("p", { staticClass: "sk-panel-subtitle" }, [
                    _vm._v(
                      "Khoản thu này sẽ bị gỡ bỏ khỏi toàn bộ phiếu thu trong phạm vi"
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "rfd-info-grid" }, [
                _c(
                  "div",
                  { staticClass: "rfd-info-row" },
                  [
                    _c("span", { staticClass: "rfd-info-label" }, [
                      _vm._v("Mã khoản:"),
                    ]),
                    _c(
                      "el-tag",
                      {
                        staticClass: "rfd-info-code",
                        attrs: {
                          size: "mini",
                          type: "danger",
                          effect: "plain",
                        },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.feeData.revenueCode || _vm.feeData.idx || "—"
                            ) +
                            "\n            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "rfd-info-row" }, [
                  _c("span", { staticClass: "rfd-info-label" }, [
                    _vm._v("Tên khoản thu:"),
                  ]),
                  _c(
                    "span",
                    { staticClass: "rfd-info-name rfd-info-name--danger" },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.feeData.currentName || _vm.feeData.label || "—"
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "rfd-info-row" }, [
                  _c("span", { staticClass: "rfd-info-label" }, [
                    _vm._v("Đơn vị tính:"),
                  ]),
                  _c("span", { staticClass: "rfd-info-value" }, [
                    _vm._v(_vm._s(_vm.feeData.unit || "Tháng")),
                  ]),
                ]),
                _vm.feeData.price
                  ? _c("div", { staticClass: "rfd-info-row" }, [
                      _c("span", { staticClass: "rfd-info-label" }, [
                        _vm._v("Đơn giá mẫu:"),
                      ]),
                      _c("span", { staticClass: "rfd-info-value" }, [
                        _vm._v(
                          _vm._s(_vm._f("formatCurrency")(_vm.feeData.price))
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "rfd-info-row" }, [
                  _c("span", { staticClass: "rfd-info-label" }, [
                    _vm._v("Phạm vi:"),
                  ]),
                  _c("span", { staticClass: "rfd-info-value" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.feeData.targetType === "GROUP" ? "Nhóm" : "Lớp"
                        ) +
                        "\n              " +
                        _vm._s(
                          _vm.feeData.targetName || _vm.feeData.className || "—"
                        ) +
                        "\n            "
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "rfd-info-row" }, [
                  _c("span", { staticClass: "rfd-info-label" }, [
                    _vm._v("Kỳ áp dụng:"),
                  ]),
                  _c("span", { staticClass: "rfd-info-value" }, [
                    _vm._v(
                      "\n              Tháng " +
                        _vm._s(_vm.feeData.month) +
                        "/" +
                        _vm._s(_vm.feeData.year) +
                        " (Đợt " +
                        _vm._s(_vm.feeData.turn) +
                        ")\n            "
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "sk-note sk-note--danger sk-u-mt-12" }, [
              _c("i", { staticClass: "el-icon-warning" }),
              _c("div", { staticClass: "rfd-danger-desc" }, [
                _c("p", [
                  _c("strong", [_vm._v("Cảnh báo quan trọng:")]),
                  _vm._v(" Hành động này sẽ xóa khoản thu\n            "),
                  _c("strong", [
                    _vm._v(
                      '"' +
                        _vm._s(_vm.feeData.currentName || _vm.feeData.label) +
                        '"'
                    ),
                  ]),
                  _vm._v(" (mã: "),
                  _c("strong", [_vm._v(_vm._s(_vm.feeData.revenueCode))]),
                  _vm._v(")\n            khỏi "),
                  _c("strong", [_vm._v("TẤT CẢ")]),
                  _vm._v(
                    " phiếu thu đã được khởi tạo của\n            " +
                      _vm._s(
                        _vm.feeData.targetType === "GROUP" ? "nhóm" : "lớp"
                      ) +
                      "\n            "
                  ),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.feeData.targetName || _vm.feeData.className)
                    ),
                  ]),
                  _vm._v("\n            trong tháng "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.feeData.month) + "/" + _vm._s(_vm.feeData.year)
                    ),
                  ]),
                  _vm._v(" đợt "),
                  _c("strong", [_vm._v(_vm._s(_vm.feeData.turn))]),
                  _vm._v(".\n          "),
                ]),
                _c("p", { staticClass: "sk-u-mt-6" }, [
                  _vm._v(
                    "\n            Nếu có bất kỳ phiếu thu chứa khoản này đã thanh toán (kể cả một phần), hệ thống sẽ chặn xóa trên toàn bộ phạm vi. Khi được phép xóa, tổng tiền và số dư của phiếu sẽ được tính lại.\n          "
                  ),
                ]),
                _c("p", { staticClass: "rfd-danger-highlight sk-u-mt-6" }, [
                  _c("i", { staticClass: "el-icon-error" }),
                  _vm._v(
                    " Thao tác này không thể hoàn tác! Bạn có chắc chắn muốn xóa không?\n          "
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }